import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import {Typography, Paper, TextField, FormControl, Select, MenuItem} from "@material-ui/core";
import actionTypes from "../../../store/actionTypes";
import {IParcela} from "../../../types";


interface IProps {
    nombre: string
    propietario: string
    usuarios: string[]
    parcela: IParcela
    setPropietario(propietario: string): void
    setNombre(nombre: string): void
}

interface IState {
}

class Caracterizacion extends React.Component<IProps, IState> {
    state: IState = {
    }

    handleSetName = (n: string) => {
        const name = n.replace(/ /gi, '')
        this.props.setNombre(name)
    }

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf: "start",
                    alignItems: "center",
                    backgroundColor: "#ddd",
                    width: '100%',
                    height: '100%',
                    overflow: "auto"
                }}
            >
                <Paper style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    width: '90%',
                    backgroundColor: "white",
                    marginTop: 20
                }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                fontWeight: "bold",
                                textAlign: "left",
                                alignSelf: "center",
                                marginLeft: 30,
                                width: '50%',
                            }}
                        >
                            Nombre de la parcela:
                        </Typography>
                        <TextField
                            style={{width: '50%', margin: 10}}
                            variant="outlined"
                            value={this.props.nombre}
                            onChange={e => this.handleSetName(e.target.value)}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                fontWeight: "bold",
                                textAlign: "left",
                                alignSelf: "center",
                                marginLeft: 30,
                                width: '50%'
                            }}
                        >
                            Propietario:
                        </Typography>
                        <FormControl
                            style={{
                                width: '30%',
                                margin: 10
                            }}
                            variant="outlined"
                        >
                            <Select
                                style={{width: '100%'}}
                                value={this.props.propietario}
                                onChange={e => this.props.setPropietario(e.target.value as string)}
                            >
                                {this.props.usuarios.map(name => <MenuItem key={name} value={name}>{name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                fontWeight: "bold",
                                textAlign: "left",
                                alignSelf: "center",
                                marginLeft: 30,
                                width: '50%'
                            }}
                        >
                            Cultivo:
                        </Typography>
                        <Typography style={{margin: 20, marginRight: 50, fontWeight: "bold"}}>
                            {this.props.parcela.cultivo}
                        </Typography>
                    </div>
                </Paper>

                <Paper style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    width: '90%',
                    backgroundColor: "white",
                    marginTop: 10
                }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                fontWeight: "bold",
                                textAlign: "left",
                                alignSelf: "center",
                                marginLeft: 30,
                                width: '50%'
                            }}
                        >
                            Huso UTM:
                        </Typography>
                        <Typography style={{margin: 20, marginRight: 50, fontWeight: "bold"}}>
                            {this.props.parcela.huso_utm}
                        </Typography>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                fontWeight: "bold",
                                textAlign: "left",
                                alignSelf: "center",
                                marginLeft: 30,
                                width: '50%'
                            }}
                        >
                            Banda UTM:
                        </Typography>
                        <Typography style={{margin: 20, marginRight: 50, fontWeight: "bold"}}>
                            {this.props.parcela.banda_utm}
                        </Typography>
                    </div>
                </Paper>

                <Paper style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    width: '90%',
                    backgroundColor: "white",
                    marginTop: 10
                }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                fontWeight: "bold",
                                textAlign: "left",
                                alignSelf: "center",
                                marginLeft: 30,
                                width: '50%'
                            }}
                        >
                            Estación meteorológica:
                        </Typography>
                        <Typography style={{margin: 20, marginRight: 50, fontWeight: "bold"}}>
                            {this.props.parcela.weather_station.replace(/,/gi, ' / ')}
                        </Typography>
                    </div>
                </Paper>

            </div>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    nombre: state.propiedades.nombre,
    propietario: state.propiedades.propietario,
    usuarios: state.principal.usuarios,
    parcela: state.propiedades.parcela
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setNombre: (nombre: string) => dispatch({type: "set-propiedades-nombre", nombre}),
    setPropietario: (propietario: string) => dispatch({type: "set-propiedades-propietario", propietario})
});

export default connect(mapStateToProps, mapDispatchToProps)(Caracterizacion);
